import { Injectable, Optional } from "@angular/core";

import * as _ from "lodash";

import { ButtonTheme } from "./modules/button/button.enum";
import { ButtonConfig } from "./modules/button/button.interface";
import { LayoutConfig } from "./modules/layout/layout.interface";
import {
  TemplateConfig,
  TemplateTypeConfig
} from "./modules/template/template.interface";
import { TemplateTheme } from "./modules/template/template.enum";

export class AppConfig {
  public button?: ButtonConfig;
  public layout?: LayoutConfig;
  public template?: TemplateConfig;
}

@Injectable()
export class ConfigService {
  constructor(@Optional() private config: AppConfig) {
    this._setDefautValues();
  }

  private DEFAULT_BUTTON_CONFIG: ButtonConfig = {
    theme: ButtonTheme.MATERIAL
  };

  private DEFAULT_LAYOUT_CONFIG: LayoutConfig = {
    relative: false,
    color: {
      primary: "#F0F0F0"
    }
  };

  private DEFAULT_TEMPLATE_CONFIG: TemplateTypeConfig = {
    theme: TemplateTheme.DEFAULT,
    header: true,
    layout: {
      header: true,
      sidebar: true
    },
    background: {
      color: "#CCCCCC"
    }
  };

  public get button(): ButtonConfig {
    return this.config && this.config.button ? this.config.button : {};
  }

  public get layout(): LayoutConfig {
    return this.config && this.config.layout ? this.config.layout : {};
  }

  public get template(): TemplateConfig {
    return this.config && this.config.template ? this.config.template : {};
  }

  private _setDefautValues() {
    if (!this.button.theme) {
      this.config.button = this.DEFAULT_BUTTON_CONFIG;
    }
    if (!this.layout.color) {
      this.config.layout = this.DEFAULT_LAYOUT_CONFIG;
    }
    _.forEach(this.template, (config, type) => {
      const default_config = this.DEFAULT_TEMPLATE_CONFIG;
      if (
        config &&
        config.background &&
        (config.background.image || config.background.color)
      ) {
        delete default_config.background.color;
      }
      this.config.template[type] = _.merge({}, default_config, config);
    });
  }
}
